import { v4 as uuid } from 'uuid';

export const MOCK_DATA = [
  { key: uuid(), value: '1' },
  { key: uuid(), value: '2' },
  { key: uuid(), value: '3' },
  { key: uuid(), value: '4' },
];
